<template>
  <div class="summary" :class="{ 'summary--sheet': cartSheet }">
    <div class="summary-card">

      <div class="summary-top-row">
        <div class="summary-title evidence">
          {{ $t('integral') }}
        </div>
        <div class="summary-odds-container" v-if="getSettings.in_combinations">
          <span class="odds-label">{{ $t('combinations') || 'Combinaciones' }}</span>
          <span class="odds-value">{{ getBet._integral_detail.combinations }}</span>
        </div>
      </div>

      <div class="summary-bottom-row">
        <div class="amount-container">
          <div class="input-group">

            <div class="combo-multiplier" v-if="getSettings.in_combinations">
              {{ getBet._integral_detail.combinations }}x
            </div>

            <button class="btn-stepper" @click="decreaseAmount">-</button>

            <input
                v-if="!isMobile"
                ref="amountInput"
                autocomplete="off"
                :value="displayAmount"
                type="text"
                inputmode="decimal"
                @focus="handleFocus"
                @blur="handleBlur"
                @input="handleInputDesktop"
                id="amount"
                class="amount-input"
            />
            <input
                v-else
                ref="amountInput"
                autocomplete="off"
                :readonly="useVirtualKeyboard"
                :inputmode="useVirtualKeyboard ? 'none' : 'decimal'"
                :value="displayAmount"
                :class="['amount-input', { 'text-selected': replaceMode }]"
                @focus="handleFocus($event)"
                @click="handleFocus($event)"
                @input="useVirtualKeyboard ? null : handleInputDesktop($event)"
                @blur="useVirtualKeyboard ? null : handleBlur()"
                id="amount"
            />

            <button class="btn-stepper" @click="increaseAmount">+</button>
          </div>
        </div>
      </div>

      <div class="keyboard-accordion-wrapper" :class="{ 'keyboard-open': showCustomKeyboard && isMobile && useVirtualKeyboard }">
        <div v-if="isMobile" class="custom-keyboard-accordion" @mousedown.prevent>
          <div class="keyboard-row">
            <button v-for="n in [1,2,3,4,5,6,7,8,9]" :key="'kb_'+n" @click="pressKey(n)">{{n}}</button>
            <button @click="pressKey(0)">0</button>
          </div>
          <div class="keyboard-row">
            <button @click="pressKey('.')">,</button>
            <button @click="backspace">⌫</button>
            <button class="close-keyboard" @click="showCustomKeyboard = false">{{ $t('close') }}</button>
          </div>
        </div>
      </div>

      <div class="container_btn_add_amount" v-if="getSettings.enableButtonsCart">
        <v-btn class="btn_add_amount_cart" px-1 py-1 v-for="(buttonCart,index) in getSettings.buttonsCart" :key="index" @click="addAmountBet(buttonCart.value)">
          +{{buttonCart.value}} {{getSettings.currencySymbol}}
        </v-btn>
      </div>

      <div class="extra-info-container" ref="infoBet" v-if="hasExtraInfo">

        <div class="extra-info-row" v-if="getSettings.in_odds_total_min">
          <span class="info-label">{{$t('odds')}} {{$t('total')}} {{$t('min')}}</span>
          <span class="info-value">x {{ getBet._integral_detail.odds_total_min | round_digits(2) | odds_type_filter }}</span>
        </div>
        <div class="extra-info-row" v-if="getSettings.in_odds_total_max">
          <span class="info-label">{{$t('odds')}} {{$t('total')}} {{$t('max')}}</span>
          <span class="info-value">x {{ getBet._integral_detail.odds_total_max | round_digits(2) | odds_type_filter }}</span>
        </div>

        <div class="extra-info-row" v-if="getSettings.in_winning_min">
          <span class="info-label">{{$t('winning')}} {{$t('min')}}</span>
          <span class="info-value">{{ getBet._integral_detail.winning_min | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>
        <div class="extra-info-row" v-if="getSettings.in_winning_max">
          <span class="info-label">{{$t('winning')}} {{$t('max')}}</span>
          <span class="info-value">{{ getBet._integral_detail.winning_max | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>

        <div class="extra-info-row" v-if="getSettings.in_bonus_min && +getBet._integral_detail.bonus_min > 0">
          <span class="info-label">{{$t('bonus')}} {{$t('min')}}</span>
          <span class="info-value">{{ getBet._integral_detail.bonus_min | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>
        <div class="extra-info-row" v-if="getSettings.in_bonus_max && +getBet._integral_detail.bonus_max > 0">
          <span class="info-label">{{$t('bonus')}} {{$t('max')}}</span>
          <span class="info-value">{{ getBet._integral_detail.bonus_max | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>

        <div class="extra-info-row" v-if="getSettings.in_profit_min">
          <span class="info-label">{{$t('profit')}} {{$t('min')}}</span>
          <span class="info-value">{{ getBet._integral_detail.profit_min | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>
        <div class="extra-info-row" v-if="getSettings.in_profit_max">
          <span class="info-label">{{$t('profit')}} {{$t('max')}}</span>
          <span class="info-value">{{ getBet._integral_detail.profit_max | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>

        <div class="extra-info-row" v-if="getSettings.in_winning_total_min">
          <span class="info-label">{{$t('winning')}} {{$t('total')}} {{$t('min')}}</span>
          <span class="info-value">{{ getBet._integral_detail.winning_total_min | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>
        <div class="extra-info-row" v-if="getSettings.in_winning_total_max">
          <span class="info-label">{{$t('winning')}} {{$t('total')}} {{$t('max')}}</span>
          <span class="info-value">{{ getBet._integral_detail.winning_total_max | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SummaryIntegral',
  inject: { cartSheet: { default: false } },
  data: () => ({
    previousAmount: null,
    showCustomKeyboard: false,
    replaceMode: false,
    windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
  }),
  mounted() {
    this.$root.$on('forceUpdateIntegral', () => {
      this.forceUpdateSummaryIntegral();
    });
    window.addEventListener('resize', this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getSettings: 'cart/getSettings',
      getMobileKeypadType: 'settings/getMobileKeypadType',
    }),
    isMobile() {
      return this.windowWidth <= 768;
    },
    useVirtualKeyboard() {
      return this.getMobileKeypadType !== 'native';
    },
    hasExtraInfo() {
      return this.getSettings.in_odds_total_min ||
          this.getSettings.in_odds_total_max ||
          this.getSettings.in_winning_min ||
          this.getSettings.in_winning_max ||
          (this.getSettings.in_bonus_min && +this.getBet._integral_detail.bonus_min > 0) ||
          (this.getSettings.in_bonus_max && +this.getBet._integral_detail.bonus_max > 0) ||
          this.getSettings.in_profit_min ||
          this.getSettings.in_profit_max ||
          this.getSettings.in_winning_total_min ||
          this.getSettings.in_winning_total_max;
    },
    displayAmount() {
      let val = this.getBet._integral_detail.amount;
      if (this.replaceMode && (!this.isMobile || !this.useVirtualKeyboard)) {
        return String(val).replace('.', ',');
      }
      return Number(val || 0).toFixed(2).replace('.', ',');
    }
  },
  watch: {
    showCustomKeyboard(val) {
      if (!val) {
        this.handleBlur();
        return;
      }
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.getElementById("modal_cart_content");
          if (!el) return;
          el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
        }, 150);
      });
    },
  },
  methods: {
    ...mapActions({
      refreshCart: 'cart/refreshCart',
    }),
    handleFocus(e) {
      this.previousAmount = this.getBet._integral_detail.amount;
      this.replaceMode = true;
      if (this.isMobile && this.useVirtualKeyboard) {
        this.showCustomKeyboard = true;
      }
      this.$nextTick(() => {
        if (e && e.target) e.target.select();
      });
    },
    handleInputDesktop(e) {
      let val = e.target.value;
      val = val.replace(/,/g, '.').replace(/[^0-9.]/g, '');

      const parts = val.split('.');
      if (parts.length > 2) {
        val = parts[0] + '.' + parts.slice(1).join('');
      }

      if (val.includes('.') && val.split('.')[1].length > 2) {
        val = val.substring(0, val.indexOf('.') + 3);
      }

      this.getBet._integral_detail.amount = val;
      this.verifyAmount(Number(val));
      this.refreshCart();
      this.vibrate();
    },
    handleBlur() {
      let amount = this.getBet._integral_detail.amount;
      if (amount === null || amount === '' || amount === undefined) {
        amount = this.previousAmount;
      }
      const min = this.getSettings.minAmount || 0;
      if (Number(amount) < min) amount = min;

      this.getBet._integral_detail.amount = Number(amount);
      this.refreshCart();

      this.showCustomKeyboard = false;
      this.replaceMode = false;
    },
    handleInput() {
      this.verifyAmount(this.getBet._integral_detail.amount);
      this.refreshCart();
      this.vibrate();
    },
    decreaseAmount() {
      let current = Number(this.getBet._integral_detail.amount) || 0;
      let min = this.getSettings.minAmount || 0;
      if (current > min) {
        this.getBet._integral_detail.amount = parseFloat(Math.max(min, current - 1).toFixed(2));
        this.handleInput();
      }
    },
    increaseAmount() {
      let current = Number(this.getBet._integral_detail.amount) || 0;
      this.getBet._integral_detail.amount = parseFloat((current + 1).toFixed(2));
      this.handleInput();
    },
    vibrate() {
      if (navigator.vibrate) navigator.vibrate(10);
    },
    addAmountBet(amount) {
      if (amount != undefined && +amount > 0.0) {
        const a = Number(this.getBet._integral_detail.amount) || 0;
        this.getBet._integral_detail.amount = parseFloat((a + Number(amount)).toFixed(2));
        this.vibrate();
        if (this.$refs.amountInput) this.$refs.amountInput.classList.add('pulse');
        setTimeout(() => {
          if (this.$refs.amountInput) this.$refs.amountInput.classList.remove('pulse');
        }, 200);
        this.refreshCart();
      }
    },
    forceUpdateSummaryIntegral() {
      this.$forceUpdate();
    },
    async verifyAmount(amount) {
      if (amount < 0) {
        this.getBet._integral_detail.amount = 0;
        await this.$store.dispatch('cart/refreshCart');
      }
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    pressKey(key) {
      let cur;
      if (this.replaceMode) {
        this.replaceMode = false;
        cur = "";
        if (key === 0) { this.getBet._integral_detail.amount = 0; this.refreshCart(); this.vibrate(); return; }
      } else {
        cur = String(this.getBet._integral_detail.amount || "");
      }
      if (cur === '' && key === 0) return;
      if (cur === '0' && key !== '.') cur = '';
      if (key === '.' && cur.includes('.')) return;
      if (key === '.' && cur === '') cur = '0';
      if (cur.includes('.') && cur.split('.')[1]?.length >= 2) {
        if (key === '.') return;
        if (cur.indexOf('.') !== -1 && cur.length - cur.indexOf('.') > 2) return;
      }
      cur += key;
      cur = cur.replace(/^0+([1-9])/, '$1').replace(/\.+/g, '.');
      if (cur.endsWith('.')) {
        this.getBet._integral_detail.amount = cur;
      } else {
        this.getBet._integral_detail.amount = Number(cur);
        this.verifyAmount(Number(cur));
      }
      this.refreshCart();
      this.vibrate();
    },
    backspace() {
      this.replaceMode = false;
      let cur = String(this.getBet._integral_detail.amount || '');
      cur = cur.slice(0, -1);
      if (cur === '' || cur === '0') {
        this.getBet._integral_detail.amount = 0;
      } else if (cur.endsWith('.')) {
        this.getBet._integral_detail.amount = cur;
      } else {
        this.getBet._integral_detail.amount = Number(cur);
      }
      this.refreshCart();
    },
  },
};
</script>

<style scoped>
.summary {
  padding: 0 0 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-card {
  background: var(--bg-card);
  border-radius: 8px;
  padding: 14px;
}

/* --- Riga Superiore (Titolo e Combinazioni) --- */
.summary-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.summary-title {
  color: var(--text-platform);
  font-weight: 700;
  font-size: var(--font-size-5xl);
  text-transform: capitalize;
}

.summary-odds-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.odds-label {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-2xl);
  text-transform: capitalize;
}

.odds-value {
  color: var(--color-primary-light);
  font-weight: 700;
  font-size: var(--font-size-6xl);
}

/* --- Riga Inferiore (Input Importo) --- */
.summary-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.amount-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.input-group {
  display: flex;
  background: var(--sidebar);
  overflow: hidden;
  width: 100%;
  gap: 4px;
  padding: 10px;
  border-radius: 8px;
}

/* Badge con le combinazioni (es. 10x) dentro l'input */
.combo-multiplier {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px 0 4px;
  color: var(--text-op-50-platform);
  font-weight: 700;
  font-size: var(--font-size-4xl);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  margin-right: 2px;
}

.btn-stepper {
  background: var(--bg-card);
  color: var(--text-platform);
  height: 36px;
  width: 36px;
  font-size: var(--font-size-7xl);
  cursor: pointer;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  flex-shrink: 0;
}

.btn-stepper:hover {
  background: rgba(255, 255, 255, 0.05);
}

.btn-stepper:active {
  background: rgba(255, 255, 255, 0.1);
}

.amount-input {
  flex: 1;
  width: 100%;
  background: var(--bg-card);
  border: none;
  color: var(--text-platform);
  font-size: var(--font-size-4xl);
  font-weight: 600;
  text-align: center;
  outline: none;
  -moz-appearance: textfield;
  border-radius: 6px;
}

.amount-input::-webkit-outer-spin-button,
.amount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.pulse {
  animation: amountPulse 0.25s ease;
}
@keyframes amountPulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.04); }
  100% { transform: scale(1); }
}

/* --- Tastierino Mobile --- */
.keyboard-accordion-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transition: grid-template-rows 0.1s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
}
.keyboard-accordion-wrapper.keyboard-open {
  grid-template-rows: 1fr;
  opacity: 1;
}
.custom-keyboard-accordion {
  overflow: hidden;
  margin-top: 0;
  padding: 0 6px;
  background: var(--bg-card);
  border-radius: 8px;
  user-select: none;
  touch-action: none;
  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.keyboard-accordion-wrapper.keyboard-open .custom-keyboard-accordion {
  padding: 10px 0 0;
  margin-top: 12px;
}
.keyboard-row {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  margin: 6px 0;
}
.keyboard-row button {
  flex: 1;
  padding: 8px 0;
  font-size: var(--font-size-7xl);
  background: var(--sidebar);
  border: none;
  border-radius: 6px;
  font-weight: 600;
  color: var(--text-platform);
  outline: none;
  transition: background 0.15s;
}
.keyboard-row button:active {
  background: #3c4652;
}
.close-keyboard {
  width: 100%;
  padding: 12px 0;
  background: #ef4444 !important;
  color: #fff;
  font-weight: bold;
  border-radius: 6px;
  font-size: var(--font-size-4xl);
}

/* --- Elementi Extra --- */
.container_btn_add_amount {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}
.btn_add_amount_cart {
  flex: 1 !important;
  background: var(--sidebar) !important;
  color: var(--text-platform) !important;
  font-size: var(--font-size-xl) !important;
  height: 36px !important;
  border-radius: 5px !important;
  font-weight: bolder !important;
  transition: all 0.15s ease !important;
}
.btn_add_amount_cart:hover {
  background: var(--sidebar) !important;
  color: #ffffff !important;
}

.extra-info-container {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.extra-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-label {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-2xl);
}
.info-value {
  color: var(--color-primary-light);
  font-weight: 600;
  font-size: var(--font-size-3xl);
}

/* ── Bottom sheet mobile ─────────────────────────────────── */
.summary--sheet .summary-card {
  border-radius: 12px;
  padding: 16px;
  border: 1px solid var(--border-color, rgba(255,255,255,0.06));
}

.summary--sheet .input-group {
  border-radius: 12px;
}

.summary--sheet .btn-stepper,
.summary--sheet .step-btn {
  border-radius: 10px;
}
</style>